import { render } from "./user-messages-modal.vue?vue&type=template&id=1c7a2d7c"
import script from "./user-messages-modal.vue?vue&type=script&lang=js"
export * from "./user-messages-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__